// extracted by mini-css-extract-plugin
export default {"reports-wrapper":"reports_reports-wrapper__YuYQy"};